// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__3II0H","OrderButton":"BuildControls_OrderButton__oX0yH","enable":"BuildControls_enable__3HNmi"};